module.exports = __webpack_public_path__ + "img/w1.8192b87b.png";